// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__b8a {
  .tableControls__c83 {
    display: flex;
    align-items: center;
    gap: calc(var(--ring-unit) * 3);
    justify-content: end;
  }

  .control__dec {
    position: relative;
    height: calc(var(--ring-unit) * 2);
    width: calc(var(--ring-unit) * 2);
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:before {
      position: absolute;
      content: '';
      top: calc(var(--ring-unit) * -1);
      right: calc(var(--ring-unit) * -1);
      bottom: calc(var(--ring-unit) * -1);
      left: calc(var(--ring-unit) * -1);
    }

    &.edit__d7b {
      span {
        color: var(--ring-icon-color);
      }

      &:hover {
        span {
          color: var(--ring-icon-hover-color);
        }
      }
    }

    &.remove__dfa {
      span {
        color: var(--ring-icon-error-color);
      }

      &:hover {
        span {
          color: var(--ring-icon-error-color);
        }
      }
    }
  }

  .addModel__b16 {
    margin-top: var(--ring-unit);
  }

  .addBtnText__d8f {
    margin-left: var(--ring-unit);
  }
}

.largeInformationBanner__eb2 {
  display: grid;
  margin-bottom: var(--ring-unit);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/common/forms/common/provider-models/provider-models.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,iCAAiC;IACjC,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,kBAAkB;MAClB,WAAW;MACX,gCAAgC;MAChC,kCAAkC;MAClC,mCAAmC;MACnC,iCAAiC;IACnC;;IAEA;MACE;QACE,6BAA6B;MAC/B;;MAEA;QACE;UACE,mCAAmC;QACrC;MACF;IACF;;IAEA;MACE;QACE,mCAAmC;MACrC;;MAEA;QACE;UACE,mCAAmC;QACrC;MACF;IACF;EACF;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC","sourcesContent":[".wrapper {\n  .tableControls {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--ring-unit) * 3);\n    justify-content: end;\n  }\n\n  .control {\n    position: relative;\n    height: calc(var(--ring-unit) * 2);\n    width: calc(var(--ring-unit) * 2);\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:before {\n      position: absolute;\n      content: '';\n      top: calc(var(--ring-unit) * -1);\n      right: calc(var(--ring-unit) * -1);\n      bottom: calc(var(--ring-unit) * -1);\n      left: calc(var(--ring-unit) * -1);\n    }\n\n    &.edit {\n      span {\n        color: var(--ring-icon-color);\n      }\n\n      &:hover {\n        span {\n          color: var(--ring-icon-hover-color);\n        }\n      }\n    }\n\n    &.remove {\n      span {\n        color: var(--ring-icon-error-color);\n      }\n\n      &:hover {\n        span {\n          color: var(--ring-icon-error-color);\n        }\n      }\n    }\n  }\n\n  .addModel {\n    margin-top: var(--ring-unit);\n  }\n\n  .addBtnText {\n    margin-left: var(--ring-unit);\n  }\n}\n\n.largeInformationBanner {\n  display: grid;\n  margin-bottom: var(--ring-unit);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__b8a`,
	"tableControls": `tableControls__c83`,
	"control": `control__dec`,
	"edit": `edit__d7b`,
	"remove": `remove__dfa`,
	"addModel": `addModel__b16`,
	"addBtnText": `addBtnText__d8f`,
	"largeInformationBanner": `largeInformationBanner__eb2`
};
export default ___CSS_LOADER_EXPORT___;
